import { GenericHandlerConfig, GenericVideo, GenericVideoHandler } from '../Generic';

export class BrightSignHdmiInputHandler extends GenericVideoHandler {
    protected _type: string;
    protected _videoId: string;

    constructor(config: GenericHandlerConfig) {
        super(config);
        this._videoUrl = 'tv:brightsign.biz/hdmi';
        this._videoId = this._videoUrl;
        this._type = 'brightsign_hdmi_input';
    }

    protected async _createNewPlayer(): Promise<GenericVideo> {
        const videoElement = await super._createNewPlayer();
        videoElement.classList.add('hdmi-brightsign-video');

        // BS Hack to start audio
        videoElement.muted = true;
        videoElement.addEventListener('canplay', () => {
            setTimeout(() => {
                videoElement.muted = this._muted;
            }, 100);
        });

        return videoElement;
    }
}
